<template>
  <form>
    <ul>
      <li class="agree_area">
        <input
            v-model="requiredAgreementsArr"
            id="agree_check1"
            value="iamNotPatient"
            type="checkbox"
        >
        <label for="agree_check1"><span></span></label>
        <span class="txt_bold">{{ $t('account.necessary') }}
        </span>
        <span>
          {{ $t('account.agree_iam_doctor') }}
        </span>
      </li>
      <li class="agree_area">
        <input
            v-model="requiredAgreementsArr"
            id="agree_check2"
            value="agreeToPolicy"
            type="checkbox"
        >
        <label for="agree_check2"><span></span></label>
        <template v-if="this.lang === 'ko-kr'">
          <span class="txt_bold">{{ $t('account.necessary') }} </span>
          <span>
            <a @click="serveTermOfUseAgreement"
               class="txt_blue pointer"
               style="border-bottom: 1px solid"
            >
              {{ $t('account.terms') }}
            </a>
          </span>
          {{ $t('account.and') }}
          <span>
            <a
                @click="serveTermOfUseAgreement"
                class="txt_blue pointer"
                style="border-bottom: 1px solid"
            >
              {{ $t('account.personal_info') }}
            </a>
          </span>
          <span>{{ $t('account.i_agree') }}</span>
        </template>
        <template v-else>
          <span class="txt_bold">{{ $t('account.necessary') }} </span>
          <span>{{ $t('account.i_agree') }}</span>
          <span>
            <a
                @click="serveTermOfUseAgreement"
                class="txt_blue pointer"
                style="border-bottom: 1px solid"
            >{{ $t('account.terms') }}</a></span>{{ $t('account.and') }}<span>
          <a
                @click="serveTermOfUseAgreement"
                class="txt_blue pointer"
                style="border-bottom: 1px solid"
            >{{ $t('account.privacy_policy') }}
            </a>
          </span>
        </template>
      </li>
    </ul>
  </form>
</template>
<script>
import {AGREEMENT} from '@/enum/lib';

export default {
  name: 'SignUpAgreement',
  data() {
    return {
      lang: localStorage.getItem('lang') ?? 'en',
      requiredAgreementsArr: []
    }
  },
  mounted() {
    this.serveTermOfUseAgreement();
  },
  methods: {
    /**
     * 서비스 이용약관과 개인정보 처리방침 동의 받는 로직
     */
    serveTermOfUseAgreement() {
      const termOfUseModalParam = {
        agreementType: AGREEMENT.TERM_OF_USE,
        agreeFuncParam: [],
        agree_check: this.requiredAgreementsArr.includes('agreeToPolicy'),
        agreeFunction: () => {
          this.requiredAgreementsArr.pushIfNotExist('agreeToPolicy');
        },
        disagreeFunction: () => {
          this.requiredAgreementsArr.removeItem('agreeToPolicy');
        },
      };

      this.$modal.show('agreement_modal', termOfUseModalParam);
    },
  }
}
</script>